export default "__VITE_ASSET__DbkVsZc4__"